import React from 'react'
import { Form, InputGroup, Row, Col } from 'react-bootstrap'
import { nullishValueToValue, nullishValueToInternalValue } from '../ArticleParse'

type MutableArea = {
  x?: number | string | null
  y?: number | string | null
  [key: string]: unknown
}

type FormArea = { x?: number | string | null; y?: number | string | null }
type FormAreaErrors = { x?: string; y?: string }
type FormAreaTouched = { x?: boolean; y?: boolean }

type Values = {
  article?: { areas?: FormArea[] } | null
}

type Errors = {
  article?: { areas?: FormAreaErrors[] }
}

type Touched = {
  article?: { areas?: FormAreaTouched[] }
}

type Props = {
  values: Values
  errors: Errors
  touched: Touched
  setFieldValue: (field: string, value: unknown) => void
  handleBlur: React.FocusEventHandler<HTMLElement>
}

export const PositionFields = ({ values, errors, touched, setFieldValue, handleBlur }: Props) => {
  return (
    <Row>
      <Form.Group as={Col}>
        <Form.Label column>記事開始位置指定</Form.Label>
        <Row>
          <Form.Group as={Col} sm={4}>
            <InputGroup size='sm' hasValidation>
              <InputGroup.Text>天から</InputGroup.Text>
              <Form.Control
                type='number'
                name='article.areas[0].y'
                value={nullishValueToValue(values.article?.areas?.[0]?.y)}
                placeholder='ナリ'
                onChange={(e) => {
                  const areas = [{ ...values.article?.areas?.[0] }] as MutableArea[]
                  areas[0].y = nullishValueToInternalValue(e.target.value)
                  const newArticle = {
                    ...values.article,
                    areas
                  }
                  setFieldValue('article', newArticle)
                }}
                onBlur={handleBlur}
                isInvalid={!!(touched.article?.areas?.[0]?.y && errors.article?.areas?.[0]?.y)}
              />
              <InputGroup.Text>段目</InputGroup.Text>
              <Form.Control.Feedback type='invalid'>{errors.article?.areas?.[0]?.y}</Form.Control.Feedback>
            </InputGroup>
          </Form.Group>
          <Form.Group as={Col} sm={4}>
            <InputGroup size='sm' hasValidation>
              <InputGroup.Text>右から</InputGroup.Text>
              <Form.Control
                type='number'
                name='article.areas[0].x'
                value={nullishValueToValue(values.article?.areas?.[0]?.x)}
                placeholder='ナリ'
                onChange={(e) => {
                  const areas = [{ ...values.article?.areas?.[0] }] as MutableArea[]
                  areas[0].x = nullishValueToInternalValue(e.target.value)
                  const newArticle = {
                    ...values.article,
                    areas
                  }
                  setFieldValue('article', newArticle)
                }}
                onBlur={handleBlur}
                isInvalid={!!(touched.article?.areas?.[0]?.x && errors.article?.areas?.[0]?.x)}
              />
              <InputGroup.Text>行目</InputGroup.Text>
              <Form.Control.Feedback type='invalid'>{errors.article?.areas?.[0]?.x}</Form.Control.Feedback>
            </InputGroup>
          </Form.Group>
        </Row>
      </Form.Group>
    </Row>
  )
}
